import { z } from "zod";

export const generalMusicSchema = z.object({
  title: z.string().min(1, "Title is required!"),
  releaseDate: z.string().optional(),
  country: z.string().optional(),
  writer: z.string().min(4, "Minimum of 4 characters!"),
  composer: z.string().min(4, "Minimum of 4 characters!"),
  notes: z.string().min(10, "Minimum of 10 characters!"),
  totalEarnings: z.coerce.number().optional(),
  totalStreams: z.coerce.number().optional(),
  genre: z
    .string()
    .transform((val) => val.split(" ").map((tag) => tag.trim()))
    .refine((arr) => arr.length > 0 && arr.every((tag) => tag.length > 0), {
      message: "At least 1 genre required",
    }),
    featuredArtiste: z
    .string()
    .transform((val) => val.split(",").map((tag) => tag.trim())).optional(),
});

export const streamDataSchema = z.record(
  z.object({
    totalEarnings: z.coerce.number().optional(),
    totalStreams: z.coerce.number().optional(),
    earning: z.preprocess((val) => Number(val) || 0, z.number().min(0)),
    stream: z.preprocess((val) => Number(val) || 0, z.number().min(0)),
    link: z.string().optional(),
   
  })
);